import { motion } from "framer-motion";
import { useInView } from 'react-intersection-observer';

const SkillBar = ({ title, level, index }) => {
    const [ref, inView] = useInView({
        triggerOnce: true, // Trigger the animation only once
        threshold: 0.2, // Adjust the threshold as needed
    });

    return (
        <div className="flex items-center gap-1" ref={ref}>
            <div className="w-2/3 md:w-1/3">{title}</div>
            <div className="w-1/3 md:w-2/3 bg-gray-200 rounded-full">
                <motion.div
                    className="h-3 md:h-5 bg-tertiary rounded-full"
                    style={{ width: level + '%' }}
                    initial={{ width: 0 }}
                    animate={inView ? { width: level + '%' } : {}}
                    transition={{ duration: 1, delay: index * 0.2 }}
                ></motion.div>
            </div>
        </div>
    );
};

export default SkillBar;